import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import RefHighlightContainer from '../common/RefHighlightContainer';
import ViewerConditionsGroup from './ViewerConditionsGroup';
import LogicGroupsDivider from '../common/LogicGroupsDivider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerTopLevelLogicGroupItem = props => {
  const {
    logicGroupIndex,
    logicGroup,
    logicOperator,
    matchStatus,
    inputUse,
    showLogicGroupOperatorToggles = false
  } = props;
  const {
    viewerClonedGroupIndex,
    dispatch,
    props: {
      useOnePanel,
      showAllFiltersInEditMode
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const onGroupHighlightFinish = useCallback(() => {
    dispatch({
      type: 'viewerClonedGroupIndex',
      payload: undefined
    });
  }, [dispatch]);
  const onClickOutsideGroup = useCallback(() => {
    if (showAllFiltersInEditMode) {
      dispatch({
        type: 'selectedViewerGroupIndex',
        payload: undefined
      });
    }
  }, [dispatch, showAllFiltersInEditMode]);
  return /*#__PURE__*/_jsxs("div", {
    onClick: onClickOutsideGroup,
    children: [logicGroupIndex !== 0 && /*#__PURE__*/_jsx(LogicGroupsDivider, {
      logicOperator: logicOperator,
      layout: useOnePanel ? 'vertical' : 'horizontal',
      showToggle: showLogicGroupOperatorToggles && logicGroupIndex === 1,
      showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
    }), /*#__PURE__*/_jsx(RefHighlightContainer, {
      onHighlightFinish: onGroupHighlightFinish,
      shouldHighlight: viewerClonedGroupIndex === logicGroupIndex,
      targetSelector: "[data-highlight-target=\"viewer-conditions-group\"]::before",
      children: /*#__PURE__*/_jsx(ViewerConditionsGroup, {
        inputUse: inputUse,
        logicGroup: logicGroup,
        logicGroupIndex: logicGroupIndex,
        matchStatus: matchStatus,
        showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
      })
    })]
  });
};
export default ViewerTopLevelLogicGroupItem;